import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginWithGoogle } from "../Actions/user";

const useAuthFacade = () => {
    const [showAlert, setShowAlert] = useState(false);
    const dispatch = useDispatch();
    const { loading, isAuthenticated, error } = useSelector((state) => state.user);

    const handleGoogleLogin = () => {
        dispatch(loginWithGoogle());
    };

    // Clear any stale auth error when login page mounts (e.g. from loadUser failing when not logged in)
    useEffect(() => {
        // Small delay to ensure this runs after any loadUser calls
        const timer = setTimeout(() => {
            dispatch({ type: "ClearAuthError" });
            setShowAlert(false);
        }, 100);
        return () => clearTimeout(timer);
    }, [dispatch]);

    useEffect(() => {
        if (error) {
            setShowAlert(true);
        }
    }, [error]);

    const handleOnClose = () => {
        if (error) {
            dispatch({ type: "ClearAuthError" });
        }
        if (isAuthenticated) {
            window.location.href = "/";
        }
        setShowAlert(false);
    };

    return {
        loading,
        isAuthenticated,
        showAlert,
        setShowAlert,
        handleGoogleLogin,
        handleOnClose,
    };
};

export default useAuthFacade;
